import React from "react";
import { Dialog, DialogButton, DialogContent, DialogFooter, DialogTitle } from "../../dialog";
import { Modal } from "../../modal";

export const OfflineDialog = ({
	title,
	message,
	close,
	onClose,
}: {
	title: string;
	message: string;
	close?: string;
	onClose?: () => void;
}) => (
	<Modal isOpen>
		<Dialog className="offline-dialog" icon="offline">
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>{message}</DialogContent>
			{close && onClose ? (
				<DialogFooter>
					<DialogButton onClick={onClose}>{close}</DialogButton>
				</DialogFooter>
			) : undefined}
		</Dialog>
	</Modal>
);
OfflineDialog.displayName = "OfflineDialog";
